import VerifyUser from './VerifyUser';
export default VerifyUser;